import { ActionProps } from "../../ts";
import { LIST_OF_SCHOOL_PAYMENT, LIST_OF_SCHOOL_PAYMENT_ERROR,SINGLE_SCHOOL_PAYMENT,SINGLE_SCHOOL_ERROR } from "../ActionTypes";

const initialState = { payments: null };

const schoolPaymentStore = (state: any = initialState, action: ActionProps) => {
  const { type, payload } = action;
  switch (type) {
    case LIST_OF_SCHOOL_PAYMENT: {
      return {
        ...state,
        payments: payload,
        payment_data: null,
      };
    }
    case LIST_OF_SCHOOL_PAYMENT_ERROR: {
      return {
        ...state,
        payments: null,
        payment_data: null,
      };
    }
    case SINGLE_SCHOOL_PAYMENT: {
      return {
        ...state,
        payment_data: payload,
      };
    }
    case SINGLE_SCHOOL_ERROR: {
      return {
        ...state,
        payment_data: null,
      };
    }
    default:
      return state;
  }
};

export default schoolPaymentStore;
